// extracted by mini-css-extract-plugin
export default {"timersWrapper":"Header_timersWrapper__ckIX4","buttonsContainer":"Header_buttonsContainer__5sM2F","buttonWrapper":"Header_buttonWrapper__5TtgA"};